import { useMemo, JSX } from "react";
import { ProgressBar } from "../..";
import { CellContext } from "@tanstack/react-table";
import { EditAbleCell } from "./styledTableCell";
import { IdentifiableRow } from "../reactiveTableRenderer";

import { isObject } from "lodash";

export const ProgressTableCell = <T extends IdentifiableRow,> ({getValue, row, table, column, canEdit, staticColumn}: CellContext<T, JSX.Element | string | undefined> & EditAbleCell) => {
  const initialValue = useMemo(() => getValue(), [getValue]);

  if (isObject(initialValue)) {
    return (
      <div style={{opacity: canEdit ? "0.5" : "1"}}>
        {initialValue}
      </div>
    )
  }

  return (
    <div style={{opacity: canEdit ? "0.5" : "1"}}>
      <ProgressBar extension={{hasExtension: true}} />
    </div>
  )
  // const onBlur = () => {
  //   if (value !==initialValue) {
  //     table.options.meta?.updateData(row.original.id, column.id, value, row)
  //   }
  // }

  // return <StyledProgressCell staticColumn={staticColumn} key={key} keyPass={key+"input"} onBlur={onBlur} onChange={(e: string) => setValue(e)} canEdit={canEdit} cellData={{value: value + "potato", style:{backgroundColor: getGraphColor(row.original.id), ...css.colorTag, ...fonts.header, ...fonts.fontSize4, color: colors.whitePrimary}}} />
}


// const StyledProgressCell = ({onBlur, onChange, canEdit, cellData, keyPass, staticColumn}: StyledTableCellProps & EditAbleCell) => {
//   if (canEdit) {
//     if (staticColumn) { 
//       return (
//         <div style={{ ...cellData, opacity: 0.5 }} key={keyPass}>
//           {String(cellData.value)}
//         </div>
//       );
//     } else {
//       return (
//         <NewInput
//           key={keyPass}
//           onChange={onChange}
//           fieldOverrides={{
//             fieldStyle: NewFieldStyles.greyTertiary,
//             fieldType: NewFieldTypes.tertiaryField,
//             fieldWidth: "100%"
//           }}
//           valueOverrides={{
//             defaultValue: cellData.value,
//             valueType: "string"
//           }}
//         />
//       );
//     }
//   }

//   return (
//     <div style={cellData.style} key={keyPass}>
//       {String(cellData.value)}
//     </div>
//   )
// } 
